import Lister from "./Lister";
export default function TradeAPlaneListingsAll() {
    return (
        <div>
          
            <div>
                <h1>
                    Trade-a-plane Listings
                </h1>
            </div>
            
            {/* <div>
                <Caller text="Enqueue Listing Summary" functionName="enqueuePlanecheckGetListingPagesCall"></Caller>
            </div>

            <div>
                <Caller text="Test Parse" functionName="testPlanecheckParse"></Caller>
            </div> */}

            <div>
                <Lister configName="tradeaplane" listingSite="tradeaplane_listings" default='placeholder_all' scrapesCollection="scrapes_v1" />
            </div>

        </div>
    );
}
